document.addEventListener('DOMContentLoaded', function () {
    const input = document.querySelector('[data-taxonomy-filter]');
    const directory = document.querySelector('[data-taxonomy-directory]');
    const noResults = document.querySelector('[data-taxonomy-no-results]');

    if (!input || !directory) return;

    input.addEventListener('input', function () {
        const query = input.value.trim().toLowerCase();
        let visibleCount = 0;

        directory.querySelectorAll('[data-taxonomy-group]').forEach(function (group) {
            let groupCount = 0;

            group.querySelectorAll('[data-taxonomy-name]').forEach(function (link) {
                const matches = !query || link.dataset.taxonomyName.includes(query);
                link.hidden = !matches;
                if (matches) groupCount += 1;
            });

            group.hidden = groupCount === 0;
            visibleCount += groupCount;
        });

        if (noResults) noResults.hidden = visibleCount !== 0;
    });
});